import { render, staticRenderFns } from "./examDetailss.vue?vue&type=template&id=e2bbc676&scoped=true"
import script from "./examDetailss.vue?vue&type=script&lang=js"
export * from "./examDetailss.vue?vue&type=script&lang=js"
import style0 from "./examDetailss.vue?vue&type=style&index=0&id=e2bbc676&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2bbc676",
  null
  
)

export default component.exports